import styled from '@emotion/styled'

const DefaultLoading = styled.div`
  display: inline-block;
  background-color: ${(props) => {
    const { backgroundColor } = props
    if (backgroundColor) {
      return backgroundColor
    }
    return 'transparent'
  }};
`
export default DefaultLoading
